module.exports = __webpack_public_path__ + "static/media/Coding.ca1fa77a.png";